// Dropdown Hover
$(document).on("click", function(event){
    var $trigger = $(".dropdown");
    if($trigger !== event.target && !$trigger.has(event.target).length){
        $(".dropdown-menu").slideUp("fast");
    }            
});
$(document).ready(function() {

    // Show hide popover
    $(document).on('click', '.hmuser,.wbcollscart', function(e) {
        $(this).toggleClass('active');
        $(this).next().slideToggle('fast');
        $(".dropdown-menu").not($(this).next()).slideUp('fast');
    });

    //Custom JQ for login popup
    // $(document).on('focus', '.hmuser', function(e) {
    //     $(this).toggleClass('active');
    //     $(this).next().slideToggle('fast');
    //     $(".dropdown-menu").not($(this).next()).slideUp('fast');
    // });

    let dropdownTimeout;

    $('.hmuser, .dropdown-menu-1').on('mouseenter', function() {
      clearTimeout(dropdownTimeout);
      $('.hmuser').addClass('active');
      $('.dropdown-menu-1').stop(true, true).slideDown('fast');
    });
    
    $('.hmuser, .dropdown-menu-1').on('mouseleave', function() {
      dropdownTimeout = setTimeout(() => {
        $('.hmuser').removeClass('active');
        $('.dropdown-menu-1').stop(true, true).slideUp('fast');
      }, 200);
    });

    // let dropdownTimeout_2;

    // $('.cstm-hov, .dropdown-menu-2').on('mouseenter click', function() {
    //   clearTimeout(dropdownTimeout_2);
    //   $('.cstm-hov').addClass('active');
    //   $('.dropdown-menu-2').stop(true, true).slideDown('fast');
    // });
    
    // $('.cstm-hov, .dropdown-menu-2').on('mouseleave click', function() {
    //   dropdownTimeout_2 = setTimeout(() => {
    //     $('.cstm-hov').removeClass('active');
    //     $('.dropdown-menu-2').stop(true, true).slideUp('fast');
    //   }, 200);
    // });

    let dropdownTimeout_2;
    const $trigger = $('.cstm-hov');
    const $menu = $('.dropdown-menu-2');
    
    // Detect if device supports hover
    const canHover = window.matchMedia('(hover: hover)').matches;
    
    // Functions to show/hide dropdown
    function showDropdown() {
      clearTimeout(dropdownTimeout_2);
      $trigger.addClass('active');
      $menu.stop(true, true).slideDown('fast');
    }
    
    function hideDropdown() {
      dropdownTimeout_2 = setTimeout(() => {
        $trigger.removeClass('active');
        $menu.stop(true, true).slideUp('fast');
      }, 200);
    }
    
    // Hover behavior for pointer devices (desktop)
    if (canHover) {
      $trigger.add($menu).on('mouseenter', showDropdown);
      $trigger.add($menu).on('mouseleave', hideDropdown);
    }
    
    // Click behavior for touch devices (mobile)
    else {
      $trigger.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($menu.is(':visible')) {
          hideDropdown();
        } else {
          showDropdown();
        }
      });
    
      // Close dropdown when clicking outside
      $(document).on('click touchstart', function (e) {
        if (!$(e.target).closest('.cstm-hov, .dropdown-menu-2').length) {
          hideDropdown();
        }
      });
    }

    //Custom Code END


    // Collapse Toggle
    $(document).on('click', '.toggle.collapsed', function(e) {
        $(this).toggleClass('active');
        $(this).next().slideToggle('fast');
    });

    // Scroll To top
    $("#scroll").addClass("scrollhide");
        $(window).scroll(function () {
        if ($(this).scrollTop() === 0) {
            $("#scroll").addClass("scrollhide")
        } else {
            $("#scroll").removeClass("scrollhide")
        }
    });
    $(document).on('click', '#scroll', function(e) {
        $("html, body").animate({scrollTop: 0}, 600);
        return false;
    });

    // Collection Grid/List View
    $(document).on('click', '.wblistgridbtn', function(e) {
        $(this).addClass('active').siblings().removeClass('active');
        if ($(this).hasClass('listv')) {
            $('#ProductGridContainer').addClass('product-list').removeClass('product-grid').removeClass('product-galleryv');
        } else if ($(this).hasClass('gridv')) {
            $('#ProductGridContainer').addClass('product-grid').removeClass('product-list').removeClass('product-galleryv');
        } else if ($(this).hasClass('galleryv')) {
            $('#ProductGridContainer').addClass('product-galleryv').removeClass('product-list').removeClass('product-grid');
        }
    });
    
}); // Document Ready Div End


// Countdown section
setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
      var countDownDate = countdownSection.getAttribute('data-date');
      var now = new Date().getTime();
      if (!countDownDate) {
          countdownSection.querySelector('.main_cdays .wb_cdays').textContent = '00';
          countdownSection.querySelector('.main_chours .wb_chours').textContent = '00';
          countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = '00';
          countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = '00';
      } else {
          countDownDate = new Date(countDownDate).getTime();
          var distance = countDownDate - now;

          if (distance < 0 || isNaN(countDownDate)) {
              countdownSection.style.display = 'none';
              let c = countdownSection.parentElement.querySelector('p.countdownMessage');
              if(c) c.style.display = 'block';
          } else {
              countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
              countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
          }
      }
  });
}